module.exports = __webpack_public_path__ + "img/swiper1.995c65b1.png";